import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

import {
  CREATE_LIS_SPECIMEN_FAILURE,
  CREATE_LIS_SPECIMEN_REQUEST,
  CREATE_LIS_SPECIMEN_SUCCESS,
  DELETE_LIS_SPECIMEN_FAILURE,
  DELETE_LIS_SPECIMEN_REQUEST,
  DELETE_LIS_SPECIMEN_SUCCESS,
  UPDATE_LIS_SPECIMEN_FAILURE,
  UPDATE_LIS_SPECIMEN_REQUEST,
  UPDATE_LIS_SPECIMEN_SUCCESS,
} from "../constants";

type updateSpecimenArgs = Parameters<
  typeof ApiService.partialUpdateAdminSpecimen
>[0];
type createSpecimenArgs = Parameters<typeof ApiService.createAdminSpecimen>[0];
type deleteSpecimenArgs = Parameters<typeof ApiService.destroyAdminSpecimen>[0];

export const updateSpecimen: AsyncSagaAction<updateSpecimenArgs> =
  createAsyncSaga(
    UPDATE_LIS_SPECIMEN_REQUEST,
    UPDATE_LIS_SPECIMEN_SUCCESS,
    UPDATE_LIS_SPECIMEN_FAILURE,
    ({ id }: updateSpecimenArgs) => `admin/specimen/${id}/update`,
    ({ id, caseId, requestBody }: updateSpecimenArgs) =>
      ApiService.partialUpdateAdminSpecimen({
        id,
        caseId,
        requestBody,
      })
  );

export const createSpecimen: AsyncSagaAction<createSpecimenArgs> =
  createAsyncSaga(
    CREATE_LIS_SPECIMEN_REQUEST,
    CREATE_LIS_SPECIMEN_SUCCESS,
    CREATE_LIS_SPECIMEN_FAILURE,
    () => `admin/specimen/create`,
    ({ requestBody }: createSpecimenArgs) =>
      ApiService.createAdminSpecimen({
        requestBody,
      })
  );

export const deleteSpecimen: AsyncSagaAction<deleteSpecimenArgs> =
  createAsyncSaga(
    DELETE_LIS_SPECIMEN_REQUEST,
    DELETE_LIS_SPECIMEN_SUCCESS,
    DELETE_LIS_SPECIMEN_FAILURE,
    ({ id }: deleteSpecimenArgs) => `admin/specimen/${id}/delete`,
    ({ id }: deleteSpecimenArgs) =>
      ApiService.destroyAdminSpecimen({
        id,
      })
  );
